export default {
  authenticationBase: '/api/v1/sessions',
  blobsToOrganizationsBase: '/api/v1/blobs-to-organizations',
  claimAuthorizationsBase: '/api/v1/claims-to-organizations',
  claimsBase: '/api/v1/claims',
  configBase: '/api/v1/config',
  cutbackReasonsBase: '/api/v1/cutbacks',
  externalContactsBase: '/api/v1/external-contacts',
  fileContainersBase: 'api/v1/file-containers',
  fileUploadBase: '/api/v1/blobs',
  housingStocksBase: 'api/v1/housing-stocks',
  importBase: 'api/v1/imports',
  insuredRisksBase: '/api/v1/insured-risks',
  insuredRisksToPoliciesBase: '/api/v1/insured-risks-to-policies',
  messageTemplatesBase: '/api/v1/message-templates',
  messageTemplatesPredefinedBase: '/api/v1/message-templates-predefined',
  organizationsBase: '/api/v1/organizations',
  organizationsToRisksBase: '/api/v1/organizations-to-risks',
  passwordBase: '/api/v1/password',
  policiesBase: '/api/v1/policies',
  policiesToRisksBase: 'api/v1/policies-to-risks',
  reportingBase: '/api/v1/reportings',
  risksBase: 'api/v1/risks',
  settlementsBase: '/api/v1/settlements',
  stripeBase: 'api/v1/stripe',
  userRolesBase: '/api/v1/user-roles/create-or-update-user',
  usersBase: '/api/v1/users',
  worklistBase: 'api/v1/worklists'
};
